import React from "react";

import ArrowLink from "../../../common/ArrowLink/arrow-link";

const TourPushEnd = () => <ArrowLink to="/tours">See all tours</ArrowLink>;

export default TourPushEnd;
